export const KeywordType = [
  { label: '제목', value: 'nttSj' },
  { label: '내용', value: 'nttCn' },
  { label: '골프장명', value: 'bizNm' },
  { label: '라운드날짜', value: 'rndDt' },
]

export const SearchType = [
  { label: '최신 등록된', value: 'recent' },
  { label: '좋아요 많은', value: 'like' },
  { label: '내가 공감한 글', value: 'mine' },
]

export const FeedbackType = [
  { label: '꿀소리', value: '01' },
  { label: '쓴소리', value: '02' },
]

export const FeedbackTitle = 'FeedbackLounge'

export type FeedbackInsertData = {
  cmpnyCd: string
  cstId: string
  regId?: string
  regDate?: string
  updId?: string
  updDate?: string
  page?: number
  nttSn?: number
  bizCd?: string
  fdbkType?: string
  email?: string
  nttSj?: string
  nttCn?: string
  rndDt?: string
  fileSeq?: number
  fileNm?: string
  fileName?: string
  fileSeqList?: number[]
  fileNameList?: string[]
  fileSourceList?: string[]
  deleteSeqList?: number[]
}

export type FeedbackListData = {
  cmpnyCd: string
  cstId: string
  nttSn: number
  regId: string
  regDate: string
  updId: string
  updDate: string
  fdbkType: string
  bizCd: string
  bizNm: string
  nttSj: string
  nttCn: string
  rndDt: string
  email: string
  readngCnt: number
  answerCnt: number
  likeCnt: number
  likesYn: string
  adminDelYn: string
  delYn: string
  useYn: string
  nickName: string
  deleteFileSeqList: number[]
  fileNameList: string[]
  fileSeqList: number[]
  praiseListCnt: number
  suggestionListCnt: number
  sortType: string
  keywordTypes?: string
}

export type FeedbackDetailData = {
  cmpnyCd: string
  cstId: string
  nttSn: number
  regId: string
  regDate: string
  updId: string
  updDate: string
  fdbkType: string
  bizCd: string
  bizNm: string
  nttSj: string
  nttCn: string
  rndDt: string
  email: string
  adminDelYn: string
  delYn: string
  useYn: string
  nickName: string
  withDrawYn: string
  readngCnt?: string
  answerCnt?: string
  deleteFileSeqList: number[]
  fileNameList: string[]
  fileSeqList: number[]
  fileSourceList: string[]
  likesYn: string
  likeCnt: number
  fileName: string[]
  fileOrgName: string[]
  fileSeq: number[]
}

export interface GetFeedbackData {
  srchOpt?: string
  srchStr?: string
  page: number
  nttSj?: string
  nttCn?: string
  sortType?: string
  keywordTypes?: string
  keyword?: string
  rndDt?: string
}

export type CommentListData = {
  commentSn: number
  commentCn: string
  parentCommentSn: number
  optionSn: number
  surveySn: number
  accessIp: string
  cstId: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  nickName: string
  withDrawYn: string
  adminDelYn: string
  useYn: string
  delYn: string
}

export const fieldCheck = {
  nttSj: '제목을 입력해 주세요.',
  nttCn: '내용을 입력해 주세요.',
  rndDt: '라운딩날짜를 입력해 주세요.',
}

export const thumbnailSizeInfo =
  '* 직접 등록 시 가로 800px × 세로 480px 크기를 권장해요.'

export const imageInfo =
  '* 라운드 인증 이미지를 업로드 해주세요. (ex. 예약문자, 스코어카드 등)'

export const emailInfo =
  '* 중요한 피드백이 있을 경우, 이메일로 안내해 드릴게요.'
interface InfoProps {
  isMobile?: boolean
}
export const ListInfo = ({ isMobile = false }: InfoProps) => {
  return (
    <>
      {!isMobile ? (
        <div
          style={{
            border: '1px solid #D09D30', // 테두리는 메인 색상
            borderRadius: '8px',
            padding: '16px',
            fontSize: '14px',
            color: '#D09D30', // 진한 녹색 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
          }}
        >
          <span style={{ fontSize: '20px' }}>📣</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                marginBottom: '4px',
              }}
            >
              골퍼의 목소리가 담긴 이 공간!
            </div>
            <div>
              칭찬은 더 나은 발전으로, 반성은 변화라는 성장으로
              <br />
              소통을 통하여 공유하고 더 나은 골프 문화를 위한 자리입니다.
              <br />
              여러분의 라운드 경험을 공유해 주세요.
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            border: '1px solid #D09D30', // 테두리는 메인 색상
            borderRadius: '8px',
            padding: '16px',
            fontSize: '14px',
            color: '#D09D30', // 진한 녹색 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
            marginBottom: '12px',
          }}
        >
          <span style={{ fontSize: '15px' }}>📣</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '13px',
                marginBottom: '4px',
              }}
            >
              골퍼의 목소리가 담긴 이 공간!
            </div>
            <div style={{ fontSize: '12px' }}>
              칭찬은 더 나은 발전으로, 반성은 변화라는 성장으로
              <br />
              소통을 통하여 공유하고 더 나은 골프 문화를 위한 자리입니다.
              <br />
              여러분의 라운드 경험을 공유해 주세요.
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export const PraiseInfo = ({ isMobile = false }: InfoProps) => {
  return (
    <>
      {!isMobile ? (
        <div
          style={{
            backgroundColor: '#e8f5e9', // 밝은 녹색 배경
            border: '1px solid #81c784', // 테두리는 메인 색상
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#2e7d32', // 진한 녹색 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
          }}
        >
          <span style={{ fontSize: '20px' }}>👏</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                marginBottom: '4px',
              }}
            >
              칭찬합니다!!
            </div>
            <div>
              라운드 하며 골프장의 좋았던점! 인증 사진은 필수! 함께 공유해요^^
              <br />
              코스, 시설, 서비스, 접근 등 여러분이 다녀온 골프장을 칭찬하여 더
              나은 골프문화를 함께 만들어가요~
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: '#e8f5e9', // 밝은 녹색 배경
            border: '1px solid #81c784', // 테두리는 메인 색상
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#2e7d32', // 진한 녹색 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
            marginBottom: '10px',
          }}
        >
          <span style={{ fontSize: '15px' }}>👏</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                marginBottom: '4px',
              }}
            >
              칭찬합니다!!
            </div>
            <div style={{ fontSize: '12px' }}>
              라운드 하며 골프장의 좋았던점! <br />
              인증 사진은 필수! 함께 공유해요^^ <br />
              코스, 시설, 서비스, 접근 등 여러분이 다녀온 골프장을
              <br />
              칭찬하여 더 나은 골프문화를 함께 만들어가요~
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export const SuggestionInfo = ({ isMobile = false }: InfoProps) => {
  return (
    <>
      {!isMobile ? (
        <div
          style={{
            backgroundColor: '#ffebee', // 연한 레드 배경
            border: '1px solid #ef5350', // 메인 레드 테두리
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#b71c1c', // 진한 레드 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
          }}
        >
          <span style={{ fontSize: '20px' }}>❗</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                marginBottom: '4px',
              }}
            >
              반성합시다!!
            </div>
            <div style={{ flexWrap: 'wrap' }}>
              가격 대비 부족한 코스관리, 불친절한 서비스 등 아쉽고 고쳐줬으면
              하는 바람을 이곳을 통해 소통해 보면 어떨까요?
              <br />
              쓴소리지만 골퍼의 목소리를 달게 들려주세요^^ 사진 인증이 많으면
              도움이 돼요!!
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: '#ffebee', // 연한 레드 배경
            border: '1px solid #ef5350', // 메인 레드 테두리
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#b71c1c', // 진한 레드 텍스트
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
            marginBottom: '10px',
          }}
        >
          <span style={{ fontSize: '15px' }}>❗</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                marginBottom: '4px',
              }}
            >
              반성합시다!!
            </div>
            <div style={{ fontSize: '12px' }}>
              가격 대비 부족한 코스관리, 불친절한 서비스 등 <br />
              아쉽고 고쳐줬으면 하는 바람을 이곳을 통해 <br />
              소통해 보면 어떨까요?
              <br />
              쓴소리지만 골퍼의 목소리를 달게 들려주세요^^ <br />
              사진 인증이 많으면 도움이 돼요!!
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export const UploadInfo = ({ isMobile = false }: InfoProps) => {
  return (
    <>
      {!isMobile ? (
        <div
          style={{
            backgroundColor: '#F5E4C1',
            border: '1px solid #D09D30',
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#A06F00',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
          }}
        >
          <span style={{ fontSize: '20px' }}>⚠️</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                marginBottom: '4px',
              }}
            >
              라운드 인증 이미지를 업로드 해주세요.
              <br />
              (예: 예약 문자, 스코어카드, 현장 사진 등)
            </div>
            <div
              style={{ color: '#ef5350', fontWeight: 'bold', fontSize: '12px' }}
            >
              *개인정보가 유출되지 않도록, 이름이나 전화번호 등의 정보는 업로드
              전에 꼭 지워주세요
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: '#F5E4C1',
            border: '1px solid #D09D30',
            borderRadius: '4px',
            padding: '16px',
            fontSize: '14px',
            color: '#A06F00',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            lineHeight: '1.6',
            marginBottom: '10px',
          }}
        >
          <span style={{ fontSize: '15px' }}>⚠️</span>
          <div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                marginBottom: '4px',
              }}
            >
              라운드 인증 이미지를 업로드 해주세요.
              <br />
              (예: 예약 문자, 스코어카드, 현장 사진 등)
            </div>
            <div
              style={{ color: '#ef5350', fontWeight: 'bold', fontSize: '12px' }}
            >
              *개인정보가 유출되지 않도록, 이름이나 전화번호 등의 <br />
              정보는 업로드 전에 꼭 지워주세요
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export const formatDateString = (dateString?: string): string => {
  if (!dateString || dateString.length !== 8) return ''

  const year = dateString.substring(0, 4)
  const month = dateString.substring(4, 6)
  const day = dateString.substring(6, 8)

  return `${year}.${month}.${day}`
}

// export const formatDateForInput = (dateString?: string): string => {
//   if (!dateString || dateString.length !== 8) return ''

//   const year = dateString.substring(0, 4)
//   const month = dateString.substring(4, 6)
//   const day = dateString.substring(6, 8)

//   return `${year}-${month}-${day}` // 하이픈(-)으로 변경
// }

// 1. props로 받은 rndDt를 HTML input에 맞는 형식으로 변환하는 함수
export const formatDateForInput = (dateString: string | undefined): string => {
  if (!dateString) return ''

  // 이미 YYYY-MM-DD 형식인 경우
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString
  }

  // YYYYMMDD 형식인 경우 (예: 20241210)
  if (/^\d{8}$/.test(dateString)) {
    return `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`
  }

  // YYYY/MM/DD 형식인 경우
  if (/^\d{4}\/\d{2}\/\d{2}$/.test(dateString)) {
    return dateString.replace(/\//g, '-')
  }

  // 기타 날짜 형식 처리
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ''
    return date.toISOString().split('T')[0]
  } catch {
    return ''
  }
}
export const smartLineBreak = (text: string) => {
  if (!text || text.length <= 15) return text

  const words = text.split(' ')
  if (words.length < 2) {
    // 공백이 없으면 중간에서 자르기
    const middle = Math.floor(text.length / 2)
    return text.substring(0, middle) + '\n' + text.substring(middle)
  }

  // 단어를 적절히 분배
  const totalLength = text.length
  let firstLine = ''
  let secondLine = ''

  for (let i = 0; i < words.length; i++) {
    const testLine = firstLine + (firstLine ? ' ' : '') + words[i]
    if (testLine.length <= totalLength / 2 + 3) {
      firstLine = testLine
    } else {
      secondLine = words.slice(i).join(' ')
      break
    }
  }

  return firstLine + '\n' + secondLine
}

interface IconProps {
  width?: string
  height?: string
  viewBox?: string
}

export const PraiseIcon: React.FC<IconProps> = ({
  width = '40px',
  height = '40px',
}) => {
  return (
    <svg
      fill="#81c784"
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      stroke="#81c784"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <g>
              <path d="M256,0C114.618,0,0,114.618,0,256s114.618,256,256,256s256-114.618,256-256S397.382,0,256,0z M256,469.333 c-117.818,0-213.333-95.515-213.333-213.333S138.182,42.667,256,42.667S469.333,138.182,469.333,256S373.818,469.333,256,469.333 z"></path>{' '}
              <path d="M341.333,213.333c23.573,0,42.667-19.093,42.667-42.667C384,147.093,364.907,128,341.333,128 c-23.573,0-42.667,19.093-42.667,42.667C298.667,194.24,317.76,213.333,341.333,213.333z"></path>{' '}
              <path d="M170.667,213.333c23.573,0,42.667-19.093,42.667-42.667c0-23.573-19.093-42.667-42.667-42.667 C147.093,128,128,147.093,128,170.667C128,194.24,147.093,213.333,170.667,213.333z"></path>{' '}
              <path d="M384,256c-11.782,0-21.333,9.551-21.333,21.333C362.667,333.434,312.101,384,256,384s-106.667-50.566-106.667-106.667 c0-11.782-9.551-21.333-21.333-21.333c-11.782,0-21.333,9.551-21.333,21.333c0,79.665,69.669,149.333,149.333,149.333 s149.333-69.669,149.333-149.333C405.333,265.551,395.782,256,384,256z"></path>{' '}
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const SuggestionIcon: React.FC<IconProps> = ({
  width = '40px',
  height = '40px',
}) => {
  return (
    <svg
      fill="#ef5350"
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      stroke="#ef5350"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <g>
              <path d="M256,0C114.618,0,0,114.618,0,256s114.618,256,256,256s256-114.618,256-256S397.382,0,256,0z M256,469.333 c-117.818,0-213.333-95.515-213.333-213.333S138.182,42.667,256,42.667S469.333,138.182,469.333,256S373.818,469.333,256,469.333 z"></path>{' '}
              <path d="M255.996,256.006c-60.999,0-117.879,41.261-139.932,99.062c-4.2,11.008,1.319,23.337,12.327,27.537 s23.337-1.319,27.537-12.327c15.887-41.64,57.194-71.605,100.068-71.605c42.858,0,84.166,29.95,100.072,71.573 c4.206,11.006,16.537,16.518,27.543,12.313s16.518-16.537,12.313-27.543C373.846,297.243,316.971,256.006,255.996,256.006z"></path>{' '}
              <path d="M176.915,207.085c8.331,8.331,21.839,8.331,30.17,0s8.331-21.839,0-30.17l-42.667-42.667 c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17L176.915,207.085z"></path>{' '}
              <path d="M335.085,207.085l42.667-42.667c8.331-8.331,8.331-21.839,0-30.17c-8.331-8.331-21.839-8.331-30.17,0l-42.667,42.667 c-8.331,8.331-8.331,21.839,0,30.17S326.754,215.416,335.085,207.085z"></path>{' '}
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const PreviewIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="15px"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29289 1.29289C9.48043 1.10536 9.73478 1 10 1H18C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V8C3 7.73478 3.10536 7.48043 3.29289 7.29289L9.29289 1.29289ZM18 3H11V8C11 8.55228 10.5523 9 10 9H5V14.5858L7.79289 11.7929C8.18342 11.4024 8.81658 11.4024 9.20711 11.7929L13 15.5858L14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19 17.5858V4C19 3.44772 18.5523 3 18 3ZM5 20V17.4142L8.5 13.9142L12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071L15 16.4142L18.9269 20.3411L18.9367 20.3508C18.7946 20.7301 18.4288 21 18 21H6C5.44772 21 5 20.5523 5 20ZM6.41421 7H9V4.41421L6.41421 7ZM14.5 13C15.3284 13 16 12.3284 16 11.5C16 10.6716 15.3284 10 14.5 10C13.6716 10 13 10.6716 13 11.5C13 12.3284 13.6716 13 14.5 13Z"
          fill="#979797"
        ></path>
      </g>
    </svg>
  )
}
